import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PageTitleService} from "./services/router/title.service";
import {merge, Subject} from "rxjs";
import {SearchProgressService} from "./services/search-progress.service";

@Component({
  selector: 'app-root',
  templateUrl: './app-router.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppRouterComponent implements OnInit {
  constructor() {
  }

  private destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {

  }
}
